"use client";

import { track } from "@vercel/analytics";
import type { ReactNode } from "react";

/**
 * Thin client island around the Hire Me anchor. Lets the parent Hero
 * stay a server component while still firing the custom `hire_click`
 * Vercel Analytics event with its location prop (hero vs footer etc).
 */
const TrackedHireLink = ({
  location,
  className,
  children,
}: {
  location: string;
  className?: string;
  children: ReactNode;
}) => (
  <a
    href="/hire"
    onClick={() => track("hire_click", { location })}
    className={className}
  >
    {children}
  </a>
);

export default TrackedHireLink;
